import { Component, Input } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { UserService } from "../../user/services/user.service";

@Component({
  selector: 'xchange-claim-comments',
  templateUrl: './claim-comments.component.html',
  styleUrl: './claim-comments.component.scss'
})
export class ClaimCommentsComponent {
constructor(
    private modalService: BsModalService,
    private userService: UserService,
  ) {}
  @Input() selectedLine: any;
  @Input() claimNumber: any;
  @Input() selectedLineNumber: any;
  @Input() claimsService: any;
  showPostedComments = false;
  showSalesComments = false;
  errorMessage: string = "";
  newComment: string = "";
  submittedFlag: boolean = false;
  onPrimaryAction: Function = (selectedId: any) => {};
  onHideModal() {
    if (this.submittedFlag) {
      this.onPrimaryAction();
    }
    this.modalService.hide("addInvoiceCommentPopupModal");
  }

  submitComment() {
    let payload = {
      line: [
        {
          invoiceLineNumber: this.selectedLineNumber,
          additionalInfoNotes: this.newComment,
          component: this.selectedLine.component,
          isSales: true,
          disputeCaseId:
            this.selectedLine?.disputeCaseId &&
            this.selectedLine?.disputeCaseId != "NA"
              ? this.selectedLine?.disputeCaseId
              : "",
        },
      ],
      claimNumber: this.claimNumber,
    };
    this.userService.progressShow("claimUpdate");
    this.claimsService.addComment(payload).subscribe(
      (res: any) => {
        this.submittedFlag = true;
        this.userService.progressHide();
        this.newComment = "";
      },
      (error: any) => {
        this.userService.progressHide();
        this.errorMessage = error.error;
      },
    );
  }
}
